module.exports = __webpack_public_path__ + "static/img/103410.e9df0da9.png";